module.exports = __webpack_public_path__ + "img/chystam-party-detail.f4c67c1.svg";